import { Check } from 'lucide-react';

const STEPS = ['导入', '映射', '检查', '结果'] as const;

export interface StepBarProps {
  readonly current: number;
}

export function StepBar({ current }: StepBarProps) {
  return (
    <nav aria-label="检查步骤" className="border-b border-slate-200 bg-slate-50">
      <ol className="mx-auto grid max-w-[1440px] grid-cols-4 px-4 sm:px-6 lg:px-8">
        {STEPS.map((label, index) => {
          const active = index === current;
          const complete = index < current;
          return (
            <li
              key={label}
              aria-current={active ? 'step' : undefined}
              className={`relative flex min-h-12 items-center justify-center gap-2 border-b-2 text-xs font-semibold sm:text-sm ${
                active
                  ? 'border-orange-600 text-orange-700'
                  : complete
                    ? 'border-slate-700 text-slate-700'
                    : 'border-transparent text-slate-400'
              }`}
            >
              <span
                className={`grid size-5 place-items-center rounded-full border text-[10px] ${
                  complete
                    ? 'border-slate-700 bg-slate-700 text-white'
                    : active
                      ? 'border-orange-600 bg-orange-50 text-orange-700'
                      : 'border-slate-300 bg-white text-slate-400'
                }`}
              >
                {complete ? <Check aria-hidden="true" className="size-3" /> : index + 1}
              </span>
              <span>{label}</span>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
